export * from './customer-fscaption-detail.component';
export * from './customer-fscaption-group.component';
export * from './customer-fscaption.component';
export * from './customer-group-fscaption-detail.component';
export * from "./view-financial-statement/financial-statement-ratio.component";